module.exports = __webpack_public_path__ + "static/media/postAssessment.caf6c891.png";